import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { usdtContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import { decimalsCache } from "../../utils/decimalsCache";

const useApproveToken = () => {
    const { account } = useWeb3React();
    const web3 = useWeb3();
    const spenderAddress = Environment.presaleContract;

    const approveToken = useCallback(
        async (tokenAddress, amount) => {
            if (!account) throw new Error("WALLET_NOT_CONNECTED");

            try {
                // Fetch decimals from cache or contract
                const decimals = await decimalsCache.getDecimals(
                    tokenAddress,
                    web3,
                    usdtContract
                );

                // Calculate amount with proper decimals
                // For amount = 0, no need to calculate
                let amountInWei;
                if (parseFloat(amount) === 0) {
                    amountInWei = "0";
                } else {
                    // Round to 6 decimal places for precision
                    const fixed = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
                    // Convert using the fetched decimals
                    amountInWei = web3.utils
                        .toBN(fixed * Math.pow(10, 6)) // Convert to integer with 6 decimals
                        .mul(web3.utils.toBN(Math.pow(10, decimals - 6))) // Scale to token decimals
                        .toString();
                }

                console.log(`Approving ${amount} tokens (${amountInWei} wei, ${decimals} decimals)`);

                return new Promise(async (resolve, reject) => {
                    const contract = usdtContract(tokenAddress, web3);
                    let gas;

                    try {
                        gas = await contract.methods
                            .approve(spenderAddress, amountInWei)
                            .estimateGas({ from: account });
                    } catch (err) {
                        return reject(err);
                    }

                    contract.methods
                        .approve(spenderAddress, amountInWei)
                        .send({ from: account, gas })
                        .on("transactionHash", (hash) => {
                            console.log("Approval tx hash:", hash);
                        })
                        .on("receipt", (receipt) => {
                            console.log("Approval confirmed:", receipt);
                            resolve({ transactionHash: receipt.transactionHash, receipt });
                        })
                        .on("error", (error) => {
                            console.error("Approval failed:", error);
                            reject(error);
                        });
                });
            } catch (error) {
                throw error;
            }
        },
        [account, web3, spenderAddress]
    );

    return { approveToken };
};

export default useApproveToken;